import { computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22c1ae3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-filter"
};
const _hoisted_2 = {
  class: "filter-row"
};
const _hoisted_3 = {
  class: "filter-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filter-label"
}, "产品名称", -1));
const _hoisted_5 = {
  class: "filter-actions"
};
const _hoisted_6 = {
  class: "batch-row"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFilter',
  props: {
    keyword: null,
    selectedCount: null
  },
  emits: ["update:keyword", "search", "reset", "batch-name", "batch-time"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /** 未勾选产品时不展示 (0)，有勾选才在按钮内追加数量 */
    const countSuffix = computed(() => props.selectedCount ? `(${props.selectedCount})` : '');
    /** 点击清除图标（click 触发的 change）时立即按空条件查询；手动删空不触发 */
    const handleChange = e => {
      if (e.type === 'click') emit('search');
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_input, {
        value: __props.keyword,
        placeholder: "请输入产品名称/dbtid/包名",
        "allow-clear": "",
        "onUpdate:value": _cache[0] || (_cache[0] = val => emit('update:keyword', val !== null && val !== void 0 ? val : '')),
        onChange: handleChange,
        onPressEnter: _cache[1] || (_cache[1] = $event => emit('search'))
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
        onClick: _cache[2] || (_cache[2] = $event => emit('reset'))
      }, {
        default: _withCtx(() => [_createTextVNode("重 置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => emit('search'))
      }, {
        default: _withCtx(() => [_createTextVNode("查 询")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
        disabled: !__props.selectedCount,
        onClick: _cache[4] || (_cache[4] = $event => emit('batch-name'))
      }, {
        default: _withCtx(() => [_createTextVNode("批量修改商品名" + _toDisplayString(_unref(countSuffix)), 1)]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_button, {
        disabled: !__props.selectedCount,
        onClick: _cache[5] || (_cache[5] = $event => emit('batch-time'))
      }, {
        default: _withCtx(() => [_createTextVNode("批量修改查询时间" + _toDisplayString(_unref(countSuffix)), 1)]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});